var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F5F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_1807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4219 12.7188H29.3906V11H27.6719V12.7188H16.3281V11H14.6094V12.7188H13.5781C12.1565 12.7188 11 13.8753 11 15.2969V30.4219C11 31.8435 12.1565 33 13.5781 33H30.4219C31.8435 33 33 31.8435 33 30.4219V15.2969C33 13.8753 31.8435 12.7188 30.4219 12.7188ZM31.2812 30.4219C31.2812 30.8957 30.8957 31.2812 30.4219 31.2812H13.5781C13.1043 31.2812 12.7188 30.8957 12.7188 30.4219V19.0781H31.2812V30.4219ZM31.2812 17.3594H12.7188V15.2969C12.7188 14.823 13.1043 14.4375 13.5781 14.4375H14.6094V16.1562H16.3281V14.4375H27.6719V16.1562H29.3906V14.4375H30.4219C30.8957 14.4375 31.2812 14.823 31.2812 15.2969V17.3594Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 20.8828H14.2656V22.6016H15.9844V20.8828Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4219 20.8828H17.7031V22.6016H19.4219V20.8828Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8594 20.8828H21.1406V22.6016H22.8594V20.8828Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2969 20.8828H24.5781V22.6016H26.2969V20.8828Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7344 20.8828H28.0156V22.6016H29.7344V20.8828Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 24.3203H14.2656V26.0391H15.9844V24.3203Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4219 24.3203H17.7031V26.0391H19.4219V24.3203Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8594 24.3203H21.1406V26.0391H22.8594V24.3203Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2969 24.3203H24.5781V26.0391H26.2969V24.3203Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 27.7578H14.2656V29.4766H15.9844V27.7578Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4219 27.7578H17.7031V29.4766H19.4219V27.7578Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8594 27.7578H21.1406V29.4766H22.8594V27.7578Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2969 27.7578H24.5781V29.4766H26.2969V27.7578Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7344 24.3203H28.0156V26.0391H29.7344V24.3203Z",
    fill: "#4B1498"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_1807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground2);
export default __webpack_public_path__ + "static/media/Background-2.3c7649276c8e7862ae8b909e809efcce.svg";
export { ForwardRef as ReactComponent };